import { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "./types/query-key-enum";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, //Defalut staletime 5 min
			refetchOnWindowFocus: true,
			experimental_prefetchInRender: true,
		},
	},
});

export const invalidateQueries = (querysToInvalidate: (QueryKeys | string)[][]) => {
	querysToInvalidate.forEach((queryKeys) => {
		queryClient
			.invalidateQueries({ queryKey: queryKeys })
			.then(() => {
				// empty
			})
			.catch(() => {
				// empty
			});
	});
};

export default queryClient;
